import featuredImage from "../assets/images/resource/featured-image-4.jpg";

const weDOSection = {
  title: "WE EXCEL ACROSS\nMULTIPLE PLATFORMS",
  featuredImage,
  text: "We demonstrate our mastery across various platforms, showcasing versatility and ingenuity in the ever-evolving digital sphere.",
  barTitleOne: "Development",
  barPercentOne: 90,
  barTitleTwo: "CMS",
  barPercentTwo: 90,
  barTitleThree: "Design",
  barPercentThree: 80,
  faqs: [
    // {
    //   id: 1,
    //   title: "We help to create visual strategies",
    //   text: "Our specialty is creating custom visual strategies that increase the visibility and impact of your brand and make it stand out in a crowded market.",
    // },
    // {
    //   id: 2,
    //   title: "ENHANCING WEB SOLUTIONS",
    //   text: "With a focus on user experience and functionality, we specialize in creating custom web solutions that strengthen the web platform and increase engagement.",
    // },
    // {
    //   id: 3,
    //   title: "STRENGTHENING BRAND IDENTITY",
    //   text: "We are passionate about developing unique brand identities that connect with your target market, help you stand out from the competition, and foster enduring relationships.",
    // },
    {
      id: 1,
      title: "CRAFTING BESPOKE DESIGNS",
      text: "We specialize in creating tailored designs that align with your brand's vision and ensure a unique and lasting impression on your audience.",
    },
    {
      id: 2,
      title: "BUILDING FUTURE-READY WEBSITES",
      text: "Our expertise lies in developing modern, responsive, and scalable websites that adapt to evolving technologies and business needs.",
    },
    {
      id: 3,
      title: "TRANSFORMING IDEAS INTO REALITY",
      text: "We transform your innovative ideas into functional digital solutions, ensuring seamless integration and unmatched quality.",
    },
    {
      id: 4,
      title: "INNOVATIVE MOBILE APPLICATIONS",
      text: "We craft innovative and user-friendly mobile applications that cater to your specific business needs and ensure seamless performance across platforms.",
    },
    {
      id: 5,
      title: "ELEVATING USER EXPERIENCE",
      text: "Our designs are centered around enhancing user experience, creating intuitive interfaces that foster engagement and leave a lasting impression.",
    }
    // ,
    // {
    //   id: 4,
    //   title: "INNOVATIVE MOBILE APPLICATIONS",
    //   text: "We craft innovative and user-friendly mobile applications that cater to your specific business needs and ensure seamless performance across platforms.",
    // },
    // {
    //   id: 5,
    //   title: "ELEVATING USER EXPERIENCE",
    //   text: "Our designs are centered around enhancing user experience, creating intuitive interfaces that foster engagement and leave a lasting impression.",
    // }

    // {
    //   id: 4,
    //   title: "MAXIMIZING MARKETING ROI",
    //   text: "We are experts in optimizing marketing campaigns to maximize ROI and produce quantifiable results for your company. We do this by utilizing data-driven insights.",
    // },
    // {
    //   id: 5,
    //   title: "OPTIMIZING SALES FUNNELS",
    //   text: "We specialize in crafting strategic sales funnels designed to streamline the customer journey and maximize conversions, ensuring optimal results for your business.",
    // },
  ],
};

export default weDOSection;
